import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccCarRentalIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccCarRentalIcon(props: MccCarRentalIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccCarRentalIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Car Rental')}
      {...rest}
    >
      <path
        d="M12.6666 8.33341H14C14.4 8.33341 14.6666 8.06675 14.6666 7.66675V5.66675C14.6666 5.06675 14.2 4.53342 13.6666 4.40008C12.4666 4.06675 10.6666 3.66675 10.6666 3.66675C10.6666 3.66675 9.79998 2.73341 9.19998 2.13341C8.86665 1.86675 8.46665 1.66675 7.99998 1.66675H3.33331C2.93331 1.66675 2.59998 1.93341 2.39998 2.26675L1.46665 4.20008C1.37837 4.45757 1.33331 4.72788 1.33331 5.00008V7.66675C1.33331 8.06675 1.59998 8.33341 1.99998 8.33341H3.33331M12.6666 8.33341C12.6666 9.06979 12.0697 9.66675 11.3333 9.66675C10.5969 9.66675 9.99998 9.06979 9.99998 8.33341M12.6666 8.33341C12.6666 7.59704 12.0697 7.00008 11.3333 7.00008C10.5969 7.00008 9.99998 7.59704 9.99998 8.33341M3.33331 8.33341C3.33331 9.06979 3.93027 9.66675 4.66665 9.66675C5.40303 9.66675 5.99998 9.06979 5.99998 8.33341M3.33331 8.33341C3.33331 7.59704 3.93027 7.00008 4.66665 7.00008C5.40303 7.00008 5.99998 7.59704 5.99998 8.33341M5.99998 8.33341H9.99998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
